'use client'

import React from 'react'

import HowToUse1Image from '@images/brands/cheongdam/how-to-use-1.png'
import HowToUse2Image from '@images/brands/cheongdam/how-to-use-2.png'
import HowToUse3Image from '@images/brands/cheongdam/how-to-use-3.png'

import { HStack, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const HowToUse = () => {
  return (
    <VStack data-aos="fade-up" my={10}>
      <VStack justifyContent="center">
        <Text textStyle={'exclusiveTitle'} textTransform="uppercase">
          How to use
        </Text>
        <Text textStyle={'fastResultText'}>
          How to use Ellixi Black Change Shampoo
        </Text>
      </VStack>
      <HStack gap={5} mt={5} maxW={600}>
        <VStack>
          <HStack
            gap={{
              md: 8,
              base: 4
            }}
            justifyContent="flex-start"
            width="100%"
          >
            <Image
              src={HowToUse1Image}
              width={120}
              height={144}
              alt={'how to use image'}
            />
            <VStack
              gap={{
                md: 4,
                base: 2
              }}
              alignItems="flex-start"
            >
              <Text textDecoration={'underline'} textStyle={'fastResultText'}>
                Step 1
              </Text>
              <Text textStyle={'fastResultText'}>
                Wet your scalp and hair with lukewarm water, get a moderate
                amount on your hand and mix the content well.
              </Text>
            </VStack>
          </HStack>

          <HStack
            gap={{
              md: 8,
              base: 4
            }}
            justifyContent="flex-start"
            width="100%"
          >
            <Image
              src={HowToUse2Image}
              width={120}
              height={144}
              alt={'how to use image'}
            />
            <VStack
              gap={{
                md: 4,
                base: 2
              }}
              alignItems="flex-start"
            >
              <Text textDecoration={'underline'} textStyle={'fastResultText'}>
                Step 2
              </Text>
              <Text textStyle={'fastResultText'}>
                Spread them on the hair and leave it for 1~2 minutes.
              </Text>
            </VStack>
          </HStack>

          <HStack
            gap={{
              md: 8,
              base: 4
            }}
            justifyContent="flex-start"
            width="100%"
          >
            <Image
              src={HowToUse3Image}
              width={120}
              height={144}
              alt={'how to use image'}
            />
            <VStack
              gap={{
                md: 4,
                base: 2
              }}
              alignItems="flex-start"
            >
              <Text textDecoration={'underline'} textStyle={'fastResultText'}>
                Step 3
              </Text>
              <Text textStyle={'fastResultText'}>
                Rinse it clean with lukewarm water.
              </Text>
            </VStack>
          </HStack>
        </VStack>
      </HStack>
    </VStack>
  )
}

export default HowToUse
